<template>
    <div class="tort_line_chart">
        <div :style="{height:'417px',paddingTop:'10px',width:'100%'}" :id="id"></div>
    </div>
</template>
<script>
    import echarts from 'echarts/lib/echarts';
    // 引入柱状图和饼状图
    import  'echarts/lib/chart/bar';
    import  'echarts/lib/chart/pie';
    // 引入提示框和标题组件
    import 'echarts/lib/component/tooltip';
    import 'echarts/lib/component/title';
    import 'echarts/lib/component/legend';
    import 'echarts/lib/component/toolbox';
    import 'echarts/lib/component/axis';
    import 'echarts/lib/component/axisPointer';
    import $ from 'jquery';
    export default {
        name:'tortLineChart',
        props:{
            lengend:{
                type:Array,
                default:()=>[]
            },
            xAxis:{
                type:Array,
                default:()=>[]
            },
            series:{
                type:Array,
                default:()=>[]
            },
            maxVal:String,
            type:String,
            id:String,
            numberD:String,
        },
        data(){
            return {
                dataList:[],
                myHeight:'417px'
            }
        },
        mounted(){
            this.$nextTick(() => {
                this.init();
            })
        },
        methods:{
            init(){
                let legend = this.lengend
                let xaxis = this.xAxis
                let data = this.series
                let maxVal = this.maxVal
                this.tortChart(legend,xaxis,data,maxVal)
            },
            // 圆柱图
            tortChart(legend,xaxis,data,maxVal){
                legend = this.lengend
                xaxis = this.xAxis
                data = this.series
                maxVal = this.maxVal
                for(var i = 0;i<data.length;i++){
                    data[i].type = "line"
                }
                var optionLineTort = {
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            crossStyle: {
                                color: '#999'
                            }
                        }
                    },
                    toolbox: {
                        feature: {
                            dataView: {show: true, readOnly: false},
                            magicType: {show: true, type: ['line', 'bar']},
                            restore: {show: true},
                            saveAsImage: {show: true}
                        }
                    },
                    legend: {
                        data:this.type=="line1"?['收益']:['侵权连接数量']
                    },
                    xAxis: [
                        {
                            type: 'category',
                            data: xaxis,
                            axisPointer: {
                                type: 'shadow'
                            }
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value',
                            name: this.type!="line1"?'侵权连接数量':'最近'+this.numberD+'日收益（元）',
                            min: 0,
                            max: maxVal,
                            interval: parseFloat(maxVal/7).toFixed(2),
                            axisLabel: {
                                formatter: '{value}'
                            }
                        }
                    ],
                    series: data     
                }
                var tortLineChart = echarts.init(document.getElementById(this.id))
                tortLineChart.on('legendselectchanged', ({ selected, name }) => {
                    selected[name] = true
                    tortLineChart.setOption({ legend: { selected } })
                })
                // 使用刚指定的配置项和数据显示图表。
                // window.onresize = function () {
                //     myLeftChart.resize();
                // }
                // 使用刚指定的配置项和数据显示图表。
                setTimeout(function(){
                    tortLineChart.setOption(optionLineTort,true)
                    tortLineChart.resize();
                },1500)
                // window.onresize = function () {
                //     myBottomChart.resize();
                // }
                $(window).resize(function(){
                    tortLineChart.resize();
                });

            }
        }
    }

</script>